// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"885e86fc","72":"2f04f3e8","477":"db728583","627":"f0ba7bb2","663":"652759ea","667":"335fcf34","777":"c0eddf96","803":"cf19d5d5","820":"37408eec"}[chunkId] + ".chunk.js";
};